import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Fireflies, ScrollParticles } from "./components/Fireflies";
import { CursorTrail } from "./components/CursorTrail";
import { Navigation } from "./components/Navigation";
import { Hero } from "./components/Hero";
import { About } from "./components/About";
import { Gallery } from "./components/Gallery";
import { Contact } from "./components/Contact";
import ImpressumPage from "./pages/ImpressumPage";
import ShopPage from "./pages/ShopPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import CartPage from "./pages/CartPage";
import CheckoutSuccessPage from "./pages/CheckoutSuccessPage";
import WiderrufPage from "./pages/WiderrufPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import GaleriePage from "./pages/GaleriePage";
import { CartProvider } from "./context/CartContext";
import { AdminAuthProvider } from "./context/AdminAuthContext";

const HomePage = () => (
  <>
    <Navigation />
    <main className="relative z-10">
      <Hero />
      <About />
      <Gallery />
      <Contact />
    </main>
  </>
);

function App() {
  return (
    <div className="App" data-testid="app-root">
      {/* Global ambient layers (present on all routes) */}
      <Fireflies count={22} />
      <ScrollParticles count={18} />
      <CursorTrail />
      <div className="grain-overlay" aria-hidden="true" />

      <AdminAuthProvider>
        <CartProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/galerie" element={<GaleriePage />} />
              <Route path="/shop" element={<ShopPage />} />
              <Route path="/shop/:id" element={<ProductDetailPage />} />
              <Route path="/cart" element={<CartPage />} />
              <Route path="/order-success" element={<CheckoutSuccessPage />} />
              <Route path="/widerruf" element={<WiderrufPage />} />
              <Route path="/impressum" element={<ImpressumPage />} />
              <Route path="/admin/login" element={<AdminLoginPage />} />
              <Route path="/admin" element={<AdminDashboardPage />} />
            </Routes>
          </BrowserRouter>
        </CartProvider>
      </AdminAuthProvider>
    </div>
  );
}

export default App;
